import React, {memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/plp"
import {TextModel} from "models/Text"
import connect from "./connect"

interface OpenFilterButtonProps {
    isFilterSelected?: boolean
    handleOpenFilterBtnClick: () => void
    isFilteredPrice: boolean
    filteredFacets: {[key: string]: string[]}
    text: TextModel
    top: number
    $height: number
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const OpenFilterButtonComponent = memo(
    ({
        isFilterSelected,
        handleOpenFilterBtnClick,
        isFilteredPrice,
        filteredFacets,
        text,
        top,
        $height,
        templating,
    }: OpenFilterButtonProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        return (
            <ComponentName
                top={top}
                $height={$height}
                handleOpenFilterBtnClick={handleOpenFilterBtnClick}
                text={text.buttons.openFilters}
                filteredFacets={filteredFacets}
                isFilterSelected={isFilterSelected}
                isFilteredPrice={isFilteredPrice}
            />
        )
    },
)
OpenFilterButtonComponent.displayName = "OpenFilterButtonComponent"

export default connect(OpenFilterButtonComponent)
